import { Paragraph } from 'docx';
import { EsrsReportStandard } from '../../Report.types';
import { TextStyle } from '../reportThemes';
import { createDisclosures } from './disclosure-requirements';

export const createStandards = (
  standards: EsrsReportStandard[],
  companyCurrency: string,
  year: number
) => {
  const visibleStandards = standards.filter(
    (standard) =>
      !standard.disclosureRequirements.every(
        (dr) => dr.isHidden || dr.metrics.every((metric) => metric.metric.isHidden)
      )
  );

  const displayedStandards = visibleStandards.flatMap((standard) => {
    return [
      new Paragraph({
        text: `${standard.reference.replace(/-/g, ' ')} ${standard.title}`,
        style: TextStyle.h1,
        spacing: {
          after: 200,
        },
      }),
      createDisclosures(
        standard.disclosureRequirements,
        companyCurrency,
        standard.targetQuestions,
        standard.actionQuestions,
        standard.reference,
        year
      ),
    ];
  });
  return displayedStandards.flat();
};
